// extracted by mini-css-extract-plugin
module.exports = {"container":"simple-quill-editor_container__3lRJY","fixed":"simple-quill-editor_fixed__h-sne"};